import { alpha, styled } from "@mui/material/styles";
import { TextField } from "@mui/material";

export const CustomTextField = styled(TextField)({
  // "& .MuiInputBase-root": {
  //   backgroundColor: "#333333",
  // },
  "& label.Mui-focused": {
    color: "#a8bbcf",
  },
  "& label": {
    color: "#444D56",
  },
  "& .MuiOutlinedInput-root": {
    "& fieldset": {
      borderColor: "#444D56",
    },
    "&:hover fieldset": {
      borderColor: "#65717e",
    },
    "&.Mui-focused fieldset": {
      borderColor: "#a8bbcf",
    },
    "&:hover .MuiInputAdornment-root .MuiSvgIcon-root": {
      color: "#65717e",
    },
    ".MuiInputAdornment-root .MuiSvgIcon-root": {
      color: "#444D56",
    },
    "&.Mui-focused .MuiInputAdornment-root .MuiSvgIcon-root": {
      color: "#a8bbcf",
    },
  },
  "& .MuiInputBase-input": {
    color: "white",
  },
  "& .MuiFormHelperText-root": {
    color: "white",
  },
});
